import { Action, createReducer, on } from '@ngrx/store';
import * as webPlayer from '../actions/web-player';

export interface State {
  sport: string;
  isSet: boolean;
  active: boolean;
}

export function getInitialState(): State {
  const session = JSON.parse(localStorage.getItem('edgeApp') as string);
  return session
    ? Object.assign({}, { isSet: true, sport: session.sport, active: false })
    : { sport: '', isSet: false, active: false };
}

const initialState: State = getInitialState();

export const webPlayerReducer = createReducer(
  initialState,
  on(webPlayer.ToggleWebPlayerSportAction, (state, action) => {
    return Object.assign({}, state, {
      sport: action.payload,
      isSet: true,
      active: false
    });
  }),
  on(webPlayer.ToggleWebPlayerDropdownAction, (state, action) => {
    const active =
      action.payload !== undefined ? action.payload : !state.active;
    return Object.assign({}, state, { active });
  }),
  on(webPlayer.RedirectWebPlayerAction, (state, action) => {
    return Object.assign({}, state, { sport: action.payload });
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return webPlayerReducer(state, action);
}

export const webPlayerSport = (state: State) => state.sport;
export const webPlayerIsSet = (state: State) => state.isSet;
export const webPlayerDropdown = (state: State) => state.active;
